import Iframe from "react-iframe";
import React, { createContext, useEffect, useState } from "react";
import API from "api";
import { getUserProfile } from "api/auth";
import BigSpinner from "utils/Spinner/BigSpinner";
import { useQuery, useQueryClient } from "react-query";
import { toastHandler } from "utils/helpers/toast";
import { getError } from "utils/helpers";

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const queryClient = useQueryClient();

  const [start, setStart] = useState(false);
  const [checkoutData, setCheckoutData] = useState({});

  const getStarterDataQuery = useQuery({
    queryKey: ["starter-data"],
    queryFn: async () => {
      const response = await API.get(getUserProfile);

      return response?.data?.data;
    },
    enabled: false,
  });

  useEffect(() => {
    getStarterDataQuery.refetch();
    // eslint-disable-next-line
  }, []);

  const {
    data: starterData,
    error: starterError,
    isError: isStarterError,
    isSuccess: isStarterSuccess,
    isFetching: isStarterFetching,
  } = getStarterDataQuery;

  const userDetails = getStarterDataQuery?.data || {};

  useEffect(() => {
    if (isStarterFetching) return;
    if (isStarterError) return toastHandler(getError(starterError));
    if (isStarterSuccess) {
      queryClient.invalidateQueries();
      setStart(true);
    }
    // eslint-disable-next-line
  }, [
    starterData,
    starterError,
    isStarterError,
    isStarterSuccess,
    isStarterFetching,
  ]);

  const { url } = checkoutData;

  useEffect(() => {
    const receiveMessage = async (event) => {
      const { data: response } = event || {};
      const { name } = response || {};

      if (name === "close") setCheckoutData({});
      else if (name === "done") {
        // eslint-disable-next-line no-unused-expressions
        checkoutData.refetch && checkoutData.refetch();
        setCheckoutData({});
      }
    };

    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage, false);
  }, [checkoutData]);

  return (
    <AuthContext.Provider
      value={{
        ...userDetails,
        setCheckoutData,
        refetch: getStarterDataQuery.refetch,
      }}
    >
      {getStarterDataQuery?.isLoading || !start ? (
        <div className="w-100 h-500 position-relative flex__column flex__center">
          <BigSpinner />
        </div>
      ) : (
        children
      )}
      {url && <Iframe url={url} id="payment" />}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
